import { InspectionTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';

const ANSWER_TYPE_LABEL_KEYS: Record<AnswerType, TranslationKey> = {
  [AnswerType.Compliance]: InspectionTranslationKeys.typeCompliance,
  [AnswerType.Numeric]: InspectionTranslationKeys.typeNumeric,
  [AnswerType.Text]: InspectionTranslationKeys.typeText,
  [AnswerType.OptionSelection]: InspectionTranslationKeys.typeOptionSelection,
};

export function answerTypeLabelKey(answerType: AnswerType): TranslationKey {
  return ANSWER_TYPE_LABEL_KEYS[answerType];
}
